import AdminPageTitle from "../../components/admin-page-title";
import { BiPlus } from "react-icons/bi";
import { useEffect, useState } from "react";
import { AiFillDelete, AiFillEdit, AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import FileUploader from "../../components/file-uploader";
import ActualiteService from "../../service/actualite.service";
import { Button, Input, InputNumber, Checkbox, Modal, Table, message } from "antd";

const actualiteService = new ActualiteService();

const FORM_IS = {
    id: undefined,
    title_fr: "",
    title_ar: "",
    title_en: "",
    summary_fr: "",
    summary_ar: "",
    summary_en: "",
    content_fr: "",
    content_ar: "",
    content_en: "",
    banner_300x600: "",
    is_active: true,
    display_order: 0
};

export default function GestionActualites() {
    const [rows, setRows] = useState([]);
    const [form, setForm] = useState(FORM_IS);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        getAll();
    }, []);

    const onEditClicked = (row) => {
        setForm(row);
        setModalVisible(true);
    };

    const onAddClicked = () => {
        resetForm();
        setModalVisible(true);
    };

    const postEntity = () => {
        setLoading(true);
        actualiteService.createActualite(form)
            .then(() => {
                getAll();
                setLoading(false);
                setModalVisible(false);
                resetForm();
                message.success("Actualité ajoutée avec succès");
            })
            .catch(() => {
                setLoading(false);
                message.error("Erreur lors de l'ajout de l'actualité");
            });
    };

    const putEntity = () => {
        setLoading(true);
        actualiteService.updateActualite(form.id, form)
            .then(() => {
                getAll();
                setLoading(false);
                setModalVisible(false);
                resetForm();
                message.success("Actualité modifiée avec succès");
            })
            .catch(() => {
                setLoading(false);
                message.error("Erreur lors de la modification de l'actualité");
            });
    };

    const deleteEntity = (id) => {
        Modal.confirm({
            title: "Êtes-vous sûr de vouloir supprimer cette actualité ?",
            onOk: () => {
                actualiteService.deleteActualite(id).then(() => {
                    getAll();
                    message.success("Actualité supprimée");
                });
            },
        });
    };

    const toggleStatus = (id) => {
        const actualite = rows.find(r => r.id === id);
        actualiteService.updateActualite(id, { ...actualite, is_active: !actualite.is_active })
            .then(() => getAll());
    };

    const submit = (e) => {
        if (e) e.preventDefault();
        if (!form.title_fr.trim()) {
            message.warning("Le titre français est requis");
            return;
        }
        if (form.id) putEntity();
        else postEntity();
    };

    const resetForm = () => {
        setForm({ ...FORM_IS });
    };

    const getAll = () => {
        actualiteService.getAllActualites()
            .then((res) => setRows(res))
            .catch((error) => console.log(error));
    };

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const columns = [
        {
            title: "Ordre",
            dataIndex: "display_order",
            key: "display_order",
            render: (order) => <span style={{ color: '#1890ff' }}>{order}</span>
        },
        {
            title: "Titre",
            dataIndex: "title_fr",
            key: "title_fr",
            render: (title, row) => <strong>{title || row.title_en || row.title_ar || `Actualité ${row.id}`}</strong>
        },
        {
            title: "Statut",
            dataIndex: "is_active",
            key: "is_active",
            render: (is_active, row) => (
                <Button
                    type={is_active ? "primary" : "default"}
                    size="small"
                    onClick={() => toggleStatus(row.id)}
                    icon={is_active ? <AiFillEye /> : <AiFillEyeInvisible />}
                />
            )
        },
        {
            title: "Date",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (date) => <small className="text-muted">{date ? new Date(date).toLocaleDateString('fr-FR') : ''}</small>
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, row) => (
                <>
                    <Button
                        type="default"
                        size="small"
                        icon={<AiFillEdit />}
                        onClick={() => onEditClicked(row)}
                        style={{ marginRight: 8 }}
                    />
                    <Button
                        type="primary"
                        danger
                        size="small"
                        icon={<AiFillDelete />}
                        onClick={() => deleteEntity(row.id)}
                    />
                </>
            )
        }
    ];

    return (
        <div>
            <AdminPageTitle title="Gestion des Actualités" />
            <div style={{ marginBottom: 16, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <h5 style={{ margin: 0 }}>Liste des Actualités</h5>
                <Button type="primary" icon={<BiPlus />} onClick={onAddClicked}>
                    Ajouter une actualité
                </Button>
            </div>
            <Table
                dataSource={rows}
                columns={columns}
                rowKey="id"
                pagination={{ pageSize: 10 }}
            />
            <Modal
                title={form.id ? "Modifier l'actualité" : "Ajouter une actualité"}
                open={modalVisible}
                onCancel={() => {
                    resetForm();
                    setModalVisible(false);
                }}
                onOk={submit}
                confirmLoading={loading}
                okText={form.id ? "Modifier" : "Enregistrer"}
                cancelText="Fermer"
                width={900}
                footer={null}
            >
                <form onSubmit={submit}>
                    <div style={{ display: "flex", gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <label>Titre (Français) *</label>
                            <Input
                                value={form.title_fr}
                                onChange={e => handleChange("title_fr", e.target.value)}
                                required
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label>Titre (Arabe)</label>
                            <Input
                                value={form.title_ar}
                                onChange={e => handleChange("title_ar", e.target.value)}
                                style={{ direction: 'rtl' }}
                            />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label>Titre (Anglais)</label>
                            <Input
                                value={form.title_en}
                                onChange={e => handleChange("title_en", e.target.value)}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: 16, marginTop: 16 }}>
                        <div style={{ flex: 1 }}>
                            <label>Résumé (Français)</label>
                            <Input.TextArea
                                rows={3}
                                maxLength={500}
                                value={form.summary_fr}
                                onChange={e => handleChange("summary_fr", e.target.value)}
                                placeholder="Résumé en français (max 500 caractères)"
                            />
                            <small style={{ color: '#888' }}>{form.summary_fr.length}/500 caractères</small>
                        </div>
                        <div style={{ flex: 1 }}>
                            <label>Résumé (Arabe)</label>
                            <Input.TextArea
                                rows={3}
                                maxLength={500}
                                value={form.summary_ar}
                                onChange={e => handleChange("summary_ar", e.target.value)}
                                placeholder="الملخص بالعربية (الحد الأقصى 500 حرف)"
                                style={{ direction: 'rtl' }}
                            />
                            <small style={{ color: '#888' }}>{form.summary_ar.length}/500 caractères</small>
                        </div>
                        <div style={{ flex: 1 }}>
                            <label>Résumé (Anglais)</label>
                            <Input.TextArea
                                rows={3}
                                maxLength={500}
                                value={form.summary_en}
                                onChange={e => handleChange("summary_en", e.target.value)}
                                placeholder="Summary in English (max 500 characters)"
                            />
                            <small style={{ color: '#888' }}>{form.summary_en.length}/500 characters</small>
                        </div>
                    </div>
                    <div style={{ display: "flex", gap: 16, marginTop: 16 }}>
                        <div style={{ flex: 1 }}>
                            <label>Contenu (Français)</label>
                            <Input.TextArea
                                rows={5}
                                maxLength={1000}
                                value={form.content_fr}
                                onChange={e => handleChange("content_fr", e.target.value)}
                                placeholder="Contenu complet en français (max 1000 caractères)"
                            />
                            <small style={{ color: '#888' }}>{form.content_fr.length}/1000 caractères</small>
                        </div>
                        <div style={{ flex: 1 }}>
                            <label>Contenu (Arabe)</label>
                            <Input.TextArea
                                rows={5}
                                maxLength={1000}
                                value={form.content_ar}
                                onChange={e => handleChange("content_ar", e.target.value)}
                                placeholder="المحتوى الكامل بالعربية (الحد الأقصى 1000 حرف)"
                                style={{ direction: 'rtl' }}
                            />
                            <small style={{ color: '#888' }}>{form.content_ar.length}/1000 caractères</small>
                        </div>
                        <div style={{ flex: 1 }}>
                            <label>Contenu (Anglais)</label>
                            <Input.TextArea
                                rows={5}
                                maxLength={1000}
                                value={form.content_en}
                                onChange={e => handleChange("content_en", e.target.value)}
                                placeholder="Full content in English (max 1000 characters)"
                            />
                            <small style={{ color: '#888' }}>{form.content_en.length}/1000 characters</small>
                        </div>
                    </div>
                    <div style={{ margin: '16px 0' }}>
                        <label>Banner Page Interne (300x600px)</label>
                        <FileUploader
                            id="banner-300x600-uploader"
                            onUrlReceived={banner_300x600 => handleChange("banner_300x600", banner_300x600)}
                            html={
                                <div
                                    style={{
                                        overflow: "hidden",
                                        borderRadius: 8,
                                        height: 200,
                                        width: "100%",
                                        border: "1px solid lightgray",
                                        cursor: "pointer",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}
                                    onClick={() => {
                                        if (typeof window !== 'undefined' && document) {
                                            const uploader = document.getElementById('banner-300x600-uploader');
                                            if (uploader) {
                                                uploader.click();
                                            }
                                        }
                                    }}
                                >
                                    {form.banner_300x600 !== "" ? (
                                        <img
                                            src={form.banner_300x600}
                                            height="100%"
                                            width="100%"
                                            alt="Banner 300x600"
                                        />
                                    ) : (
                                        <div style={{ textAlign: "center" }}>
                                            <span style={{ fontSize: "2rem", color: "#6c757d" }}>+</span>
                                            <p style={{ color: "#6c757d", margin: 0 }}>
                                                Cliquez pour télécharger<br />Banner 300x600px
                                            </p>
                                        </div>
                                    )}
                                </div>
                            }
                        />
                        <small style={{ color: '#888' }}>
                            Recommandé: 300x600 pixels pour la page actualités
                        </small>
                    </div>
                    <div style={{ display: "flex", gap: 16 }}>
                        <div style={{ flex: 1 }}>
                            <label>Ordre d'affichage</label>
                            <InputNumber
                                min={0}
                                style={{ width: "100%" }}
                                value={form.display_order}
                                onChange={value => handleChange("display_order", value || 0)}
                            />
                        </div>
                        <div style={{ flex: 1, marginTop: 32 }}>
                            <Checkbox
                                checked={form.is_active}
                                onChange={e => handleChange("is_active", e.target.checked)}
                            >
                                Actualité active (visible sur le site)
                            </Checkbox>
                        </div>
                    </div>
                    <div style={{ marginTop: 24, textAlign: "right" }}>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            {form.id ? "Modifier" : "Enregistrer"}
                        </Button>
                        <Button
                            style={{ marginLeft: 8 }}
                            onClick={() => {
                                resetForm();
                                setModalVisible(false);
                            }}
                        >
                            Fermer
                        </Button>
                    </div>
                </form>
            </Modal>
        </div>
    );
}